import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterSearch: [],

  region: undefined,
  eventName: undefined,
  startDate: undefined,
  endDate: undefined,
  markup: undefined,

  allEvents: [],
  eventPage: 1,
  eventsLoading: true,
  DateExistsWithinEvent: false,
};

const eventSlice = createSlice({
  name: "event",
  initialState: initialState,
  reducers: {
    setEventsLoading(state, action) {
      state.eventsLoading = action.payload.eventsLoading;
    },
    setEventNextPage(state) {
      state.eventPage++;
    },
    setEventPrevPage(state) {
      state.eventPage--;
    },
    setFilterSearchPush: (state, action) => {
      let region = action.payload.filterSearchRegion;
      state.filterSearch.push(region);
    },
    setFilterSearch(state, action) {
      state.filterSearch = action.payload.filterSearch;
    },
    setRegion(state, action) {
      state.region = action.payload.region;
    },
    getAllEvents(state, action) {
      state.allEvents = action.payload.allEvents;
    },
    setDateExistWithinEvent(state, action) {
      state.DateExistsWithinEvent = action.payload.DateExistsWithinEvent;
    },
  },
});

export const {
  setEventsLoading,
  setEventNextPage,
  setEventPrevPage,
  setFilterSearch,
  setFilterSearchPush,
  setRegion,
  getAllEvents,
  setDateExistWithinEvent,
} = eventSlice.actions;
export const eventSliceReducer = eventSlice.reducer;
